// extracted by mini-css-extract-plugin
module.exports = {"ll-logo":"lakeshore-icon_ll-logo___h_FD","ll-logo-red":"lakeshore-icon_ll-logo-red__yjH2B"};